import { useState } from "react";
import { ethers, BigNumber } from "ethers";
import {
  RunbitCollectionAddress,
  RBCTAddress,
  RBETAddress,
  RBCTAbi,
  RBETAbi,
  RBAddress,
  RBAbi,
  USDT,
  USDTAbi,
  RunbitCollectionAbi,
  equipAddress,
  equipAbi,
  cardAddress,
  cardAbi,
  RunbitAddress,
  RunbitAbi,
} from "../contract/address";
import useWallet from "./Wallet/useWallet";

export default function useContract() {
  const ethereum = window.ethereum || (window.bitkeep && window.bitkeep.ethereum);
  const [provider, setProvider] = useState(() => {
    if (ethereum) {
      return new ethers.providers.Web3Provider(ethereum);
    }
    return "";
  });
  const [quickProvider, setQuickProvider] = useState(() => {
    if (ethereum) {
      return new ethers.providers.JsonRpcProvider(
        "https://nameless-serene-model.matic.quiknode.pro/1f1fb3c76ee84cdde7921f8ee612c87e92da9900/"
      );
    }
    return "";
  });
  const [collectContract, setCollectContract] = useState();
  const [quilityContract, setQuilityContract] = useState();
  const [RBETContract, setRBETContract] = useState();
  const [RBCTContract, setRBCTContract] = useState();

  const [eqiupContract, setEqiupContract] = useState();
  const [USDTContract, setUSDTContract] = useState();
  const [RBContract, setRBContract] = useState();
  const [runContract, setRunContract] = useState();
  const { myAccount } = useWallet();

  const createContract = async (address, abi) => {
    let readContract, writeContract;
    if (ethereum) {
      try {
        const signer = provider.getSigner();
        readContract = new ethers.Contract(address, abi, provider);
        writeContract = readContract.connect(signer);
      } catch (error) {
        console.error(error);
      }
    } else {
      console.warn("Please authorize to access tour account");
    }
    return writeContract;
  };
  const createQuickContract = async (address, abi) => {
    return new ethers.Contract(address, abi, quickProvider);
  };
  const contractApprove = async (tokenContract, spender) => {
    let tx = tokenContract.approve(spender, "100000000000000000000000000000");
    return tx;
  };
  // 属性卡 兑换使用 RBCT
  const getRBCTContract = () => {
    if (!RBCTContract) {
      return createContract(RBCTAddress, RBCTAbi).then((contract) => {
        setRBCTContract(contract);
        return contract;
      });
    }
    return RBCTContract;
  };
  const getQuilityContract = () => {
    if (!quilityContract) {
      return createContract(cardAddress, cardAbi).then((contract) => {
        setQuilityContract(contract);
        return contract;
      });
    }
    return quilityContract;
  };
  // 装备 兑换使用 RBET
  const getRBETContract = () => {
    if (!RBETContract) {
      return createContract(RBETAddress, RBETAbi).then((contract) => {
        setRBETContract(contract);
        return contract;
      });
    }
    return RBETContract;
  };
  // 装备
  const getEqiupContract = () => {
    if (!eqiupContract) {
      return createContract(equipAddress, equipAbi).then((contract) => {
        setEqiupContract(contract);
        return contract;
      });
    }
    return eqiupContract;
  };
  // RB
  const getRBContract = () => {

    return createContract(RBAddress, RBAbi).then((contract) => {
      setRBContract(contract);
      return contract;
    });

  };
  // collect
  const getCollectContract = () => {
    console.log('RunbitCollectionAddress',RunbitCollectionAddress)
    if (!collectContract) {
      return createContract(RunbitCollectionAddress, RunbitCollectionAbi).then(
        (contract) => {
          setCollectContract(contract);
          return contract;
        }
      );
    }
    return collectContract;
  };

  const getRunContract = () => {
    if (!runContract) {
      return createContract(RunbitAddress, RunbitAbi).then((contract) => {
        setRunContract(contract);
        return contract;
      });
    }
    return runContract;
  };

  const getUSDTContract = () => {
    if (!USDTContract) {
      return createContract(USDT, USDTAbi).then((contract) => {
        setUSDTContract(contract);
        return contract;
      });
    }
    return USDTContract;
  };
  // 余额
  // RBCT
  const getRBCTBalance = async () => {
    const contract = await getRBCTContract();
    return contract.balanceOf(myAccount.account).then((balance) => {
      return balance.toString();
    });
  };
  const getRBETBalance = async () => {
    const contract = await getRBETContract();
    return contract.balanceOf(myAccount.account).then((balance) => {
      return balance.toString();
    });
  };
  // 属性卡
  const getQuilityBalance = async () => {
    const contract = await getQuilityContract();
    return contract.balanceOf(myAccount.account).then((balance) => {
      return parseInt(balance);
    });
  };
  // 装备
  const getEqiupBalance = async () => {
    const contract = await getEqiupContract();
    return contract.balanceOf(myAccount.account).then((balance) => {
      return parseInt(balance);
    });
  };
  // RB
  const getRBBalance = async () => {
    const contract = await getRBContract();
    return contract.balanceOf(myAccount.account).then((balance) => {
      return ethers.utils.formatEther(balance);
    });
  };
  // USDT
  const getUSDTBalance = async () => {
    const contract = await getUSDTContract();
    return contract.balanceOf(myAccount.account).then((balance) => {
      console.log('getUSDTBalance',balance)
      return ethers.utils.formatEther(balance);
    }).catch((e) => {
      console.log(e)
    });
    // return ethereum
    //   .request({
    //     method: "eth_getBalance",
    //     params: [myAccount.account, "latest"],
    //   })
    //   .then((balance) => {
    //     return (Number(balance) / Math.pow(10, 18)).toFixed(3);
    //   });
  };

  // 获取授权

  const getContractForAllowance = async (contract, toContract) => {
    contract.allowance(myAccount.account, toContract).then((data) => {
      if (data.eq(BigNumber.from(0))) {
        return false;
      } else {
        return true;
      }
    });
  };

  // 兑换使用  属性卡
  const getRBCTAllowance = async () => {
    const contract = await getRBCTContract();
    return contract
      .allowance(myAccount.account, RunbitCollectionAddress)
      .then((data) => {
        if (data.eq(BigNumber.from(0))) {
          return false;
        } else {
          return true;
        }
      });
  };
  // 兑换使用  装备
  const getRBETAllowance = async () => {
    const contract = await getRBETContract();
    return contract
      .allowance(myAccount.account, RunbitCollectionAddress)
      .then((data) => {
        if (data.eq(BigNumber.from(0))) {
          return false;
        } else {
          return true;
        }
      });
  };
  // 属性卡
  const getQuilityAllowance = async () => {
    const contract = await getQuilityContract();
    return contract
      .allowance(myAccount.account, RunbitCollectionAddress)
      .then((data) => {
        if (data.eq(BigNumber.from(0))) {
          return false;
        } else {
          return true;
        }
      });
  };
  // 装备
  const getEqiupAllowance = async () => {
    const contract = await getEqiupContract();
    return contract
      .allowance(myAccount.account, RunbitCollectionAddress)
      .then(async (data) => {
        if (data.eq(BigNumber.from(0))) {
          return false;
        } else {
          return true;
        }
      });
  };
  // RB
  const getRBAllowance = async () => {
    const contract = await getRBContract();
    return contract
      .allowance(myAccount.account, RunbitCollectionAddress)
      .then(async (data) => {
        if (data.eq(BigNumber.from(0))) {
          return false;
        } else {
          return true;
        }
      });
  };
  // NFT
  //获取授权情况 tokenContract对operate授权的情况
  const getNFTApprove = async () => {
    const contract = await getEqiupContract();
    return contract.isApprovedForAll(
      myAccount.account,
      RunbitCollectionAddress
    );
  };
  //授权 tokenContract对operate授权
  const setApproveNFT = async () => {
    const contract = await getEqiupContract();
    return contract.setApprovalForAll(RunbitCollectionAddress, true);
  };

  // 设置授权
  // RBCT
  const setRBCTAllowance = async () => {
    const contract = await getRBCTContract();
    return contractApprove(contract, RunbitCollectionAddress);
  };
  // RBET
  const setRBETAllowance = async () => {
    const contract = await getRBETContract();
    return contractApprove(contract, RunbitCollectionAddress);
  };
  // 属性卡
  const setQuilityAllowance = async () => {
    const contract = await getQuilityContract();
    return contractApprove(contract, RunbitCollectionAddress);
  };
  // 装备
  const setEqiupAllowance = async () => {
    const contract = await getEqiupContract();
    return contractApprove(contract, RunbitCollectionAddress);
  };
  // RB
  const setRBAllowance = async () => {
    const contract = await getRBContract();
    return contractApprove(contract, RunbitCollectionAddress);
  };

  return {
    provider,
    getCollectContract,
    getRunContract,

    getNFTApprove,
    setApproveNFT,
    getEqiupContract,
    getQuilityContract,

    getRBContract,
    getRBBalance,
    getRBAllowance,
    setRBAllowance,

    getRBCTContract,
    getRBCTBalance,
    getRBCTAllowance,
    setRBCTAllowance,

    getRBETContract,
    getRBETBalance,
    getRBETAllowance,
    setRBETAllowance,

    getUSDTBalance,
  };
}
